module.exports = __webpack_public_path__ + "linearIcons.2f3e9f80fff7d699dd3d.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/abassey/side-proj/emp21-new/src/fonts/linearIcons.ttf?w118d
// module id = ../../../../../src/fonts/linearIcons.ttf?w118d
// module chunks = styles